export default __webpack_public_path__ + "static/media/Spinner.dc4b66f8.gif";